import React from 'react';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';
import Empty from '../../../Empty.jsx';

const ChangeImpactTypeSelect = ({ changeImpactTypes, data }) => {
  return changeImpactTypes ? (
    <Field
      id="changeImpactTypeId"
      name="change_impact_type_id"
      label="Impact Type"
      componentClass="select"
      customClass="m-b-12"
      component={FieldGroup}
    >
      <option value="" disabled>
        - Select a Impact Type -
      </option>
      {changeImpactTypes
        .filter(
          (ciType) =>
            !ciType.archived ||
            (data &&
              ciType.archived &&
              `${ciType.id}` === `${data.changeImpactTypeId}`)
        )
        .sort((a, b) => a.priority - b.priority)
        .map((impact) => (
          <option key={`${impact.id}${impact.key}`} value={`${impact.id}`}>
            {impact.name}
          </option>
        ))}
    </Field>
  ) : (
    <Empty simplified />
  );
};

export default ChangeImpactTypeSelect;
